module.exports = __webpack_public_path__ + "img/status-photo-2.b12b4e0e.png";